<template>
  <div class="login-form login-signup">
    <form
        class="form"
        novalidate="novalidate"
        id="kt_login_signup_form"
    >
      <div class="pb-13 pt-lg-0 pt-5">
        <h3
            class="font-weight-bolder text-dark font-size-h4 font-size-h1-lg"
        >
          Sign Up
        </h3>
        <p class="text-muted font-weight-bold font-size-h4">
          Enter your details to create your account
        </p>
      </div>
      <div class="form-group">
        <input
            class="form-control form-control-solid h-auto py-7 px-6 rounded-lg font-size-h6"
            type="text"
            placeholder="Fullname"
            name="fullname"
            ref="fullname"
            autocomplete="off"
        />
      </div>
      <div class="form-group">
        <input
            class="form-control form-control-solid h-auto py-7 px-6 rounded-lg font-size-h6"
            type="email"
            placeholder="Email"
            name="email"
            ref="remail"
            autocomplete="off"
        />
      </div>
      <div class="form-group">
        <input
            class="form-control form-control-solid h-auto py-7 px-6 rounded-lg font-size-h6"
            type="password"
            placeholder="Password"
            name="password"
            ref="rpassword"
            autocomplete="off"
        />
      </div>
      <div class="form-group">
        <input
            class="form-control form-control-solid h-auto py-7 px-6 rounded-lg font-size-h6"
            type="password"
            placeholder="Confirm password"
            name="cpassword"
            ref="cpassword"
            autocomplete="off"
        />
      </div>
      <div class="form-group">
        <label class="checkbox mb-0">
          <input type="checkbox" name="agree" />
          <span class="mr-2"></span>
          I Agree the
          <a href="#" class="ml-2">terms and conditions</a>.
        </label>
      </div>
      <div class="form-group d-flex flex-wrap pb-lg-0 pb-3">
        <button
            ref="kt_login_signup_submit"
            class="btn btn-primary font-weight-bolder font-size-h6 px-8 py-4 my-3 mr-4"
            style="width: 150px"
        >
          Submit
        </button>
        <button
            type="button"
            id="kt_login_signup_cancel"
            class="btn btn-light-primary font-weight-bolder font-size-h6 px-8 py-4 my-3"
            @click="showForm('signin1')"
        >
          Cancel
        </button>
      </div>
    </form>
  </div>
</template>

<script>
export default {
  name: "signUpForm",
}
</script>
